import reducer from "./personalTeamReducers";

export default reducer;
